import useMedia from 'use-media';

const breakpoints = {
    sm: 767,
    md: 768,
};

export const useMediaDesktop = (): boolean => {
    const isWide = useMedia({ minWidth: `${breakpoints.md}px` });
    return isWide;
};

export const useMediaMobile = (): boolean => {
    const isMobile = useMedia({ maxWidth: `${breakpoints.sm}px` });
    return isMobile;
};

export const getMediaMobile = (): MediaQueryList => matchMedia(`(max-width: ${breakpoints.sm}px)`);
